var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinnerBlack = function SvgSpinnerBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m62.8 22.9v17.6c-15.5 0-25.3 13.7-25.3 31.6 0 17.9 12.6 32.5 28.1 32.5v17.6c-25.7 0-46.6-22.5-46.6-50.1 0-27.6 18.1-49.2 43.8-49.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m21.5 21h41.3v37.2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m80.4 120.3v-17.6c15.5 0 25.3-13.7 25.3-31.6 0-17.9-12.6-32.5-28.1-32.5v-17.6c25.7 0 46.6 22.5 46.6 50.1 0 27.6-18.1 49.2-43.8 49.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m121.7 122.2h-41.3v-37.2"
  })))));
};
export { SvgSpinnerBlack as ReactComponent };
export default __webpack_public_path__ + "assets/46ba67b7.svg";